/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { subscriptionsPause } from "../../funcs/subscriptionsPause.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  id: z.string(),
};

export const tool$subscriptionsPause: ToolDefinition<typeof args> = {
  name: "subscriptions-pause",
  description: `Pause a subscription.

Temporarily pause a subscription. Stop billing while retaining the subscription for later resumption.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await subscriptionsPause(
      client,
      args.id,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
